import { render, staticRenderFns } from "./ProviderNotification.vue?vue&type=template&id=464085b6&"
import script from "./ProviderNotification.vue?vue&type=script&lang=js&"
export * from "./ProviderNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports